import * as React from 'react';

import { cva } from 'class-variance-authority';
import {
  Building2Icon,
  CalendarIcon,
  DollarSignIcon,
  FingerprintIcon,
  HashIcon,
  LucideCoins,
  MailIcon,
  MapPinIcon,
  PhoneIcon,
  TagIcon,
  TagsIcon,
  TextIcon,
  UserRoundIcon,
  UsersRoundIcon,
  WeightIcon,
} from 'lucide-react';

import { cn } from '../../../../lib/stylingUtils';

const ID = ({ size = 12 }: HeaderIconProps) => (
  <span className={cn('@ID', iconVariants({ color: 'primary' }))}>
    <FingerprintIcon size={size} />
  </span>
);

const Address = ({ size = 12 }: HeaderIconProps) => (
  <span className={cn('@Address', iconVariants())}>
    <MapPinIcon size={size} />
  </span>
);

const Company = ({ size = 12 }: HeaderIconProps) => (
  <span className={cn('@Company', iconVariants())}>
    <Building2Icon size={size} />
  </span>
);

const Currency = ({ size = 12 }: HeaderIconProps) => (
  <span className={cn('@Currency', iconVariants())}>
    <DollarSignIcon size={size} />
  </span>
);

const Date = ({ size = 12 }: HeaderIconProps) => (
  <span className={cn('@Date', iconVariants())}>
    <CalendarIcon size={size} />
  </span>
);

const Email = ({ size = 12 }: HeaderIconProps) => (
  <span className={cn('@Email', iconVariants())}>
    <MailIcon size={size} />
  </span>
);

const Number = ({ size = 12 }: HeaderIconProps) => (
  <span className={cn('@Number', iconVariants())}>
    <HashIcon size={size} />
  </span>
);

const Person = ({ size = 12 }: HeaderIconProps) => (
  <span className={cn('@Person', iconVariants())}>
    <UserRoundIcon size={size} />
  </span>
);

const People = ({ size = 12 }: HeaderIconProps) => (
  <span className={cn('@People', iconVariants())}>
    <UsersRoundIcon size={size} />
  </span>
);

const Phone = ({ size = 12 }: HeaderIconProps) => (
  <span className={cn('@Phone', iconVariants())}>
    <PhoneIcon size={size} />
  </span>
);

const Tag = ({ size = 12 }: HeaderIconProps) => (
  <span className={cn('@Tag', iconVariants())}>
    <TagIcon size={size} />
  </span>
);

const Tags = ({ size = 12 }: HeaderIconProps) => (
  <span className={cn('@Tags', iconVariants())}>
    <TagsIcon size={size} />
  </span>
);

const Text = ({ size = 12 }: HeaderIconProps) => (
  <span className={cn('@Text', iconVariants())}>
    <TextIcon size={size} />
  </span>
);

const Weight = ({ size = 12 }: HeaderIconProps) => (
  <span className={cn('@Weight', iconVariants())}>
    <WeightIcon size={size} />
  </span>
);

const Coins = ({ size = 12 }: HeaderIconProps) => (
  <span className={cn('@Coins', iconVariants())}>
    <LucideCoins size={size} />
  </span>
);

const iconVariants = cva('rounded p-0.75', {
  variants: {
    color: {
      primary: 'bg-primary/10 text-primary/40',
      neutral: 'bg-foreground/5 text-foreground/80',
    },
  },
  defaultVariants: {
    color: 'neutral',
  },
});

type HeaderIconProps = {
  size?: number;
};

export type HeaderIcon = (props: HeaderIconProps) => React.JSX.Element;

export const HeaderIcons = {
  ID,
  Address,
  Company,
  Currency,
  Date,
  Email,
  Number,
  Person,
  People,
  Phone,
  Tag,
  Tags,
  Text,
  Weight,
  Coins,
};
